import { useState } from "react";
import { X } from "lucide-react";

import img1 from "../../public/FullSizeRender.jpeg";
import img2 from "../../public/FullSizeRender2.jpeg";
import img3 from "../../public/IMG_6515.jpeg";
import img4 from "../../public/IMG_6517.jpeg";
import img5 from "../../public/IMG_6699.jpeg";
import img6 from "../../public/IMG_6719.jpeg";
import img7 from "../../public/IMG_6722.jpeg";
import img8 from "../../public/IMG_7112.JPEG";
import img9 from "../../public/IMG_7475.jpeg";
import img10 from "../../public/IMG_7480.jpeg";

const images = [
  { src: img1, alt: "Cake creation" },
  { src: img2, alt: "Cake creation" },
  { src: img3, alt: "Baked goods" },
  { src: img4, alt: "Baked goods" },
  { src: img5, alt: "Baked goods" },
  { src: img6, alt: "Baked goods" },
  { src: img7, alt: "Baked goods" },
  { src: img8, alt: "Baked goods" },
  { src: img9, alt: "Baked goods" },
  { src: img10, alt: "Baked goods" },
];

export function Gallery() {
  const [selected, setSelected] = useState<number | null>(null);

  return (
    <section className="mx-auto max-w-7xl px-6 py-20">
      <div className="mb-12 text-center space-y-4">
        <h1 className="font-serif text-5xl text-foreground">
          Our <span className="italic text-primary">Creations</span>
        </h1>
        <p className="text-lg text-muted-foreground">
          A look at some of our favorite bakes.
        </p>
      </div>

      <div className="columns-1 gap-4 sm:columns-2 lg:columns-3">
        {images.map((img, i) => (
          <button
            key={img.src}
            onClick={() => setSelected(i)}
            className="mb-4 block w-full overflow-hidden rounded-xl border border-white/5 transition-all hover:border-primary/30 hover:shadow-lg focus:outline-none"
          >
            <img
              src={img.src}
              alt={img.alt}
              className="w-full object-cover"
              loading="lazy"
            />
          </button>
        ))}
      </div>

      {/* Lightbox */}
      {selected !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
          onClick={() => setSelected(null)}
        >
          <button
            onClick={() => setSelected(null)}
            className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors"
          >
            <X className="size-8" />
          </button>
          <img
            src={images[selected].src}
            alt={images[selected].alt}
            className="max-h-[90vh] max-w-[90vw] rounded-lg object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
